var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_990_21069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5293 17.5372C19.9266 19.9367 27.0015 27.0003 27.0015 27.0003C27.0015 27.0003 37.1387 16.8782 37.254 16.751H37.2556C38.3335 15.574 39 13.9561 39 12.1686C39 8.57698 36.3143 5.66699 33 5.66699C29.6857 5.66699 27 8.57698 27 12.1686C27 12.3474 27 12.3474 27 12.1686C27 8.57698 24.3143 5.66699 21 5.66699C17.6857 5.66699 15 8.57698 15 12.1686C15 13.7335 15.5101 15.168 16.3603 16.289",
    fill: "#F5FBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12.1686C27 8.57698 29.6857 5.66699 33 5.66699C36.3143 5.66699 39 8.57698 39 12.1686C39 13.9561 38.3335 15.574 37.2556 16.751H37.254C37.1387 16.8782 27.0015 27.0003 27.0015 27.0003C27.0015 27.0003 19.9266 19.9367 17.5293 17.5372L16.3603 16.289C15.5101 15.168 15 13.7335 15 12.1686C15 8.57698 17.6857 5.66699 21 5.66699C24.3143 5.66699 27 8.57698 27 12.1686ZM27 12.1686C27 12.3474 27 12.3474 27 12.1686Z",
    stroke: "#228C80",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 49H9.57291L9.59375 46.1875H12.9375C13.6319 46.1875 14.2187 46.0208 14.6979 45.6875C15.184 45.3542 15.5521 44.8576 15.8021 44.1979C16.059 43.5312 16.1875 42.7118 16.1875 41.7396V41.0833C16.1875 40.3542 16.1146 39.7153 15.9687 39.1667C15.8299 38.6111 15.6215 38.1493 15.3437 37.7812C15.066 37.4062 14.7187 37.125 14.3021 36.9375C13.8924 36.75 13.4201 36.6562 12.8854 36.6562H9.51041V33.8333H12.8854C13.9132 33.8333 14.8542 34.0104 15.7083 34.3646C16.5694 34.7118 17.3125 35.2118 17.9375 35.8646C18.5694 36.5104 19.0556 37.2778 19.3958 38.1667C19.7431 39.0486 19.9167 40.0278 19.9167 41.1042V41.7396C19.9167 42.809 19.7431 43.7882 19.3958 44.6771C19.0556 45.566 18.5729 46.3333 17.9479 46.9792C17.3229 47.625 16.5833 48.125 15.7292 48.4792C14.8819 48.8264 13.9514 49 12.9375 49ZM11.6667 33.8333V49H8.01041V33.8333H11.6667ZM32.2604 46.1875V49H24.1771V46.1875H32.2604ZM25.4792 33.8333V49H21.8229V33.8333H25.4792ZM31.2187 39.8542V42.5729H24.1771V39.8542H31.2187ZM32.2917 33.8333V36.6562H24.1771V33.8333H32.2917ZM40.1875 37.0208L36.4896 49H32.5625L38.1354 33.8333H40.625L40.1875 37.0208ZM43.25 49L39.5417 37.0208L39.0625 33.8333H41.5833L47.1875 49H43.25ZM43.1042 43.3437V46.1667H35.3229V43.3437H43.1042Z",
    fill: "#228C80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 10.3329C44.3333 12.9111 42.244 15.0004 39.6658 15.0004C37.0877 15.0004 35 12.9111 35 10.3329C35 7.75466 37.0893 5.66699 39.6658 5.66699C42.2423 5.66699 44.3333 7.75634 44.3333 10.3329Z",
    fill: "#F9839A",
    stroke: "#228C80",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6662 8.33301V12.333",
    stroke: "white",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 10.333H37.6667",
    stroke: "white",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_990_21069"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.3333,
    height: 53.3333,
    fill: "white",
    transform: "translate(0.333328 0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDea);
export default __webpack_public_path__ + "static/media/Ic_DEA.f5b7eeb102c7d33f8cbc529f27911ec1.svg";
export { ForwardRef as ReactComponent };